import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Privacy() {
  return (
    <div className="App">
      <Header />
      <main className="xs-page" data-testid="privacy-page">
        <div className="xs-container" style={{ maxWidth: 760 }}>
          <h1 style={{ color: "#ffde16", margin: "10px 0 4px" }}>privacy</h1>
          <p style={{ opacity: 0.85, fontSize: "0.9em" }}>
            xaelserpent.com is a one-person platform built on the principle that you shouldn't
            have to surrender your identity to read a blog post or play a video.
          </p>

          <article className="xs-article" style={{ padding: 0, marginTop: 14 }}>
            <h2>what we don't do</h2>
            <ul>
              <li>we do not set any cookies — first-party or third-party.</li>
              <li>we do not track you across sites.</li>
              <li>we do not store your IP address.</li>
              <li>we do not sell, share, or sync any data with advertisers.</li>
              <li>we do not require an account to read or play media.</li>
            </ul>

            <h2>what we do store</h2>
            <p>
              to understand which posts resonate, we count anonymized page views and media plays.
              when you visit, the server computes a one-way hash:
            </p>
            <pre>visitor_hash = sha256(your_ip + daily_salt)[:32]</pre>
            <p>
              the salt is a fresh random 16-byte value generated each UTC day. it is stored
              server-side only and rotated automatically. the salt is irretrievable from the hash,
              and the salt itself expires after 90 days. that means:
            </p>
            <ul>
              <li>the same visitor on the same day produces the same hash → useful for unique-visitor counts.</li>
              <li>the same visitor on the next day produces a <em>different</em> hash → no cross-day tracking.</li>
              <li>raw IPs are never stored. analytics events auto-expire after 60 days.</li>
            </ul>

            <h2>what we collect</h2>
            <ul>
              <li><strong>page views</strong>: the path you visited and the referring site (e.g. "x.com").</li>
              <li><strong>media events</strong>: whether an audio or video was played or completed.</li>
              <li><strong>device class</strong>: mobile / tablet / desktop / bot — derived from your user-agent string. we do not store the raw UA string for analytics.</li>
            </ul>

            <h2>newsletter</h2>
            <p>
              if you opt in to the mailing list, we store your e-mail address only. there is intentionally
              <strong> no in-platform "send" button</strong> — emails live as a private list to be used off-site
              for major releases. you can unsubscribe at any time via the link in any future mail.
            </p>

            <h2>contact</h2>
            <p>
              for any question or removal request, e-mail{" "}
              <a href="mailto:xaelserpent@gmail.com">xaelserpent@gmail.com</a>.
            </p>

            <hr />
            <p style={{ fontSize: "0.85em", opacity: 0.75 }}>
              <Link to="/">← back to home</Link>
            </p>
          </article>
        </div>
      </main>
      <Footer show />
    </div>
  );
}
